import React from "react";
import { useDispatch } from "react-redux";
import AlertService from "../../../../services/alerts/alert.service";
import "../../../../styles/components/dialogs/websiteConfigurations/manageBannersTableComponent.scss";

export const ManageBannersTableComponent = ({ banners, onDelete }) => {
  const dispatch = useDispatch();

  const handleDelete = async (bannerId) => {
    const userChoice = await AlertService.confirm("האם אתה בטוח שברצונך למחוק באנר זה?", "שים לב, פעולה זו בלתי הפיכה", "כן מחק", "בטל");
    if (!userChoice) return;

    onDelete(bannerId);
  };

  if (!banners || Object.keys(banners).length === 0) return null;

  return (
    <div className="existingBannersTable">
      <div className="tableHeader">
        <div>תמונה</div>
        <div>פעולות</div>
      </div>
      <div className="tableBody">
        {banners.map((banner) => (
          <div key={banner.Id} className="tableRow">
            <div className="bannerImage">
              <img src={banner.Url} alt="Banner" />
            </div>
            <div className="bannerActions">
              <button className="actionButton deleteButton" onClick={() => handleDelete(banner.Id)}>
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageBannersTableComponent;
